





















/* General */
import Vue from 'vue'
import moment from 'moment'

/* Mixins */

/* Components */
import CalendarMainLoading from '../components/calendar-main-loading.vue'
import CalendarDeadlines from '../components/calendar-deadlines.vue'
import CalendarActivity from '../components/calendar-activity.vue'

/* Helpers */

/* Data types */
import {
  ICalendarOutputActivity,
  ICalendarOutputDeadline,
} from '@/api/types/response.types'

/* API */

export default Vue.extend({
  name: 'CalendarMain',

  components: {
    CalendarMainLoading,
    CalendarDeadlines,
    CalendarActivity,
  },

  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    currentDate: {
      type: String,
      required: true,
    },
    activities: {
      type: Array as () => ICalendarOutputActivity[],
      default: null,
    },
    deadlines: {
      type: Array as () => ICalendarOutputDeadline[],
      default: null,
    },
  },
  data() {
    return {
      moment,
    }
  },
})
